<template>
  <header :class="$style.root">
    <div :class="$style.content">
      <h1 :class="$style.title">{{ page?.title }}</h1>

      <CoreDateTimeRangeComponent
        v-if="page?.dateStart || page?.dateEnd"
        :class="$style.dateRange"
        :dateStart="page?.dateStart"
        :dateEnd="page?.dateEnd"
        format="D MMMM YYYY"
      />

      <h2
        v-if="page?.secondaryTitle"
        :class="$style.secondaryTitle"
      >
        {{ page?.secondaryTitle }}
      </h2>

      <div :class="$style.stroke" />

      <div
        v-if="page?.externalLocation === true"
        :class="$style.externalLocation"
      >
        <span :class="$style.externalLocationLabel">{{ $t('shared.externalLocation') }}</span>
      </div>

      <slot />
    </div>
  </header>
</template>

<script lang="ts" setup>
const props = defineProps<{
  page: object
}>()

const route = useRoute()
const query = computed(() => filterRouteQuery(route?.query))
</script>

<style module>
.root {
  composes: container from global;

  display: grid;
  grid-template-columns: 1fr min-content;
  gap: var(--unit--default);
}

.content {
  /* NOTE to compensate for the container--100vw--background stroke */
  margin-left: calc((var(--unit--default) / 2) * -1);
  margin-right: calc((var(--unit--default) / 2) * -1);

  padding-left: calc((var(--unit--default) / 2) );
  padding-right: calc((var(--unit--default) / 2) );

  background-color: var(--color--background);

  width: calc(100% + var(--unit--default));
}


.title {
  composes: reset-heading from global;
  composes: font-size-x-large from global;
}

.label {
  composes: font-size-x-large from global;
  margin-left: var(--unit--default);
}

.dateRange {
  composes: font-size-x-large from global;
}

.secondaryTitle {
  composes: reset-heading from global;
  composes: font-size-medium from global;
}

.stroke {
  margin-left: calc((var(--unit--default) / 2) * -1);
  margin-right: calc((var(--unit--default) / 2) * -1);

  /* NOTE UNIFY */
  border-bottom: var(--stroke--medium) solid;
  padding-bottom: calc(var(--stroke--medium) * 2);

  grid-column: 1 / -1;
}

.externalLocation {
  composes: font-size-small font-helvetica from global;

  margin-top: var(--lh);

  grid-column: 1 / -1;
}

.externalLocationLabel {
  composes: label-inverted from global;
}
</style>
